/**
 * Saved Items API client.
 * All calls require auth (Bearer token via shared api client).
 */

import { api } from '@/shared/lib/api-client'
import type { ApiResponse } from '@abdallah-issa/shared'
import type { SavedItem, SaveInput } from './types'

export function fetchSavedItems(type?: string, signal?: AbortSignal) {
  const path = type ? `/saved-items?type=${type}` : '/saved-items'
  return api.get<SavedItem[]>(path, { auth: true, signal })
}

export function fetchCollections(signal?: AbortSignal) {
  return api.get<Array<{ collection: string; count: number }>>(
    '/saved-items/collections',
    { auth: true, signal },
  )
}

export function saveItem(input: SaveInput): Promise<ApiResponse<{ id: string; updated: boolean }>> {
  return api.post('/saved-items', input, { auth: true })
}

export function unsaveById(id: string): Promise<ApiResponse<{ deleted: boolean }>> {
  return api.delete(`/saved-items/${id}`, { auth: true })
}

export function unsaveByItem(
  itemType: string,
  itemId: string,
): Promise<ApiResponse<{ deleted: boolean }>> {
  return api.delete(
    `/saved-items/by-item?type=${encodeURIComponent(itemType)}&id=${encodeURIComponent(itemId)}`,
    { auth: true },
  )
}

export function updateSavedItem(
  id: string,
  updates: { note?: string | null; collection?: string | null },
): Promise<ApiResponse<{ updated: boolean }>> {
  return api.patch(`/saved-items/${id}`, updates, { auth: true })
}

export function bulkSave(
  items: SaveInput[],
): Promise<ApiResponse<{ inserted: number; total: number }>> {
  return api.post('/saved-items/bulk', { items }, { auth: true })
}
